// todo: why do you need to suffix every modal key with a word 'modal'?

export enum ModalIDEnum {
  LocationModal = "location-modal",
  RestaurantClosed = "restaurant-closed",
  TelegramModal = "telegram-modal",
  ContactsModal = "contacts-modal",
  SearchProductsModal = "search-products-modal",
  CartModal = "cart-modal",
  MobMenuModal = "mob-menu-modal",
  OutdatedAppWarning = "outdated-app-warning",
  AuthModal = "auth-modal",
  RegisterModal = "register-modal",
  ResetPasswordModal = "reset-password-modal",
  ProductModal = "product-modal",
}
